import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { applyAuthSession } = useAuthContext();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const token = searchParams.get('token');
    const userParam = searchParams.get('user');
    const redirectPath = searchParams.get('redirect');
    const error = searchParams.get('error');

    if (error) {
      console.error('Authentication error:', error);
      navigate('/login?error=authentication_failed', { replace: true });
      return;
    }

    if (token && userParam) {
      try {
        // searchParams.get already URL-decodes once
        let user;
        try {
          user = JSON.parse(userParam);
        } catch {
          user = JSON.parse(decodeURIComponent(userParam));
        }

        applyAuthSession(token, user);

        let finalRedirect = '/';
        if (redirectPath) {
          try {
            finalRedirect = decodeURIComponent(redirectPath);
          } catch {
            finalRedirect = redirectPath;
          }
        }
        if (!finalRedirect.startsWith('/')) {
          finalRedirect = '/';
        }

        navigate(finalRedirect, { replace: true });
      } catch (err) {
        console.error('Error parsing user data:', err);
        navigate('/login?error=authentication_failed', { replace: true });
      }
    } else {
      navigate('/login?error=authentication_failed', { replace: true });
    }
  }, [searchParams, navigate, applyAuthSession]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2
      }}
    >
      <CircularProgress />
      <Typography variant="h6">Authenticating...</Typography>
    </Box>
  );
};

export default AuthCallback;
